// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 PRO React examples
import DefaultNavbar from "custom/Navbars/DefaultNavbar";
import DefaultFooter from "custom/Footers/DefaultFooter";

// Overview page sections
import Counters from "pages/about-us/company/Overview/sections/Counters";
import ServiceBlocks from "pages/about-us/company/Overview/sections/ServiceBlocks";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/backgrounds/test.mp4";

import "@fortawesome/fontawesome-free/css/all.min.css";
import Testimonials from "pages/about-us/company/Overview/sections/Testimonials";

function Overview() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "/support/contact-us",
          label: "Comienza Ahora",
          color: "info",
        }}
        mobile={{
          color: "dark",
        }}
        sticky
      />
      <MKBox
        minHeight="80vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto" textAlign="center">
            <MKTypography
              variant="h1"
              color="white"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                fontWeight: 900,
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              No hay mejor defensa que un buen ataque
            </MKTypography>
            <MKTypography variant="body1" color="white" textAlign="center" px={6} mt={1}>
              Servicios de Seguridad Ofensiva
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 0,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Counters />
        <ServiceBlocks />
        <Testimonials />
        <MKBox pt={10} pb={6}>
          <Container>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={5} ml="auto" sx={{ textAlign: { xs: "center", lg: "left" } }}>
                <MKTypography variant="h4" fontWeight="bold" mb={0.5}>
                  ¡Conéctate con Nosotros!
                </MKTypography>
                <MKTypography variant="body1" color="text">
                  Más que un negocio, somos una comunidad.
                </MKTypography>
              </Grid>
              <Grid
                item
                xs={12}
                lg={7}
                my={{ xs: 5, lg: "auto" }}
                mr={{ xs: 0, lg: "auto" }}
                sx={{ textAlign: { xs: "center", lg: "right" } }}
              >
                <MKSocialButton
                  component="a"
                  href="https://x.com/k0x_offsec"
                  target="_blank"
                  color="twitter"
                  sx={{ m: 1 }}
                >
                  <i className="fab fa-x-twitter" /> {/* Actualiza la clase del icono si FontAwesome tiene un icono actualizado para "X" */}
                  &nbsp;Publicar
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://github.com/orgs/pwncat-offsec"
                  target="_blank"
                  color="github"
                  sx={{ m: 1 }}
                >
                  <i className="fab fa-github" />
                  &nbsp;Participa
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://www.linkedin.com/company/96064718"
                  target="_blank"
                  color="linkedin"
                  sx={{ m: 1 }}
                >
                  <i className="fab fa-linkedin" />
                  &nbsp;Descubre
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://www.youtube.com/channel/UCzobc3PZEQSsEMF7IFCKryA"
                  target="_blank"
                  color="youtube"
                  sx={{ m: 1 }}
                >
                  <i className="fab fa-youtube" />
                  &nbsp;Sigue
                </MKSocialButton>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Overview;